import React from 'react';
import './BlogPage.css';

export default function BlogPage() {
  return (
    <div className="pageContainer">
      <h1>ChronoTech Blog</h1>
      <p>Articles, stories, and robotics insights from the ChronoTech team.</p>

      <div className="articleBox">
        <h2>🧠 Why Every Kid Should Learn Robotics</h2>
        <p>Robotics builds logic, confidence, and creativity in children. Here's why it matters now more than ever.</p>
        <span className="date">Posted: August 17, 2025</span>
      </div>

      <div className="articleBox">
        <h2>⚙️ Behind the Scenes: Designing the Kits</h2>
        <p>We prototype, test, and ship our educational kits with care — learn how it’s all done behind the scenes.</p>
        <span className="date">Posted: August 15, 2025</span>
      </div>
    </div>
  );
}
